import Alert from "@mui/material/Alert"
import Typography from "@mui/material/Typography"

import ContactSupportLink from "./ContactSupportLink"
import {
  mlsPendingActivationMessage,
  mlsPurchasePaidCustomerMessage,
} from "./mlsPurchaseActivationCopy"

export default function MlsPurchaseResultBanner({ purchase, onDismiss }) {
  if (!purchase) {
    return null
  }

  const names = (purchase.mls_names || []).filter(Boolean).join(", ")
  if (purchase.assignment_status === "assigned") {
    return (
      <Alert severity="success" onClose={onDismiss} sx={{ mb: 2 }}>
        {names ? (
          <Typography variant="body2">
            <strong>{names}</strong> {names.includes(",") ? "are" : "is"} now on
            your account.
          </Typography>
        ) : (
          "Your MLS purchase has been applied to your account."
        )}
      </Alert>
    )
  }

  if (purchase.assignment_status === "failed") {
    return (
      <Alert severity="error" onClose={onDismiss} sx={{ mb: 2 }}>
        <Typography variant="body2">
          We couldn&apos;t add one or more MLS automatically. Please{" "}
          <ContactSupportLink
            subject={`MLS purchase setup – ${purchase.id}`}
            body={`Purchase ID: ${purchase.id}\nMLS: ${names}`}
            label="contact support"
          />
          .
        </Typography>
      </Alert>
    )
  }

  if (purchase.status === "paid" && purchase.assignment_status === "pending") {
    const assignAfterDate = purchase.assign_after
      ? new Date(purchase.assign_after)
      : null
    const pastDue =
      assignAfterDate && !Number.isNaN(assignAfterDate.getTime())
        ? assignAfterDate.getTime() <= Date.now()
        : false

    return (
      <Alert
        severity={pastDue ? "warning" : "success"}
        onClose={onDismiss}
        sx={{ mb: 2 }}
      >
        <Typography variant="body2">
          {pastDue ? (
            <>
              Payment received for <strong>{names || "your MLS"}</strong>.{" "}
              {mlsPendingActivationMessage(purchase.assign_after)}{" "}
              <ContactSupportLink
                subject={`MLS not enabled after purchase ${purchase.id}`}
                body={`Purchase ID: ${purchase.id}\nMLS: ${names}`}
                label="Contact support"
              />
              .
            </>
          ) : (
            <>
              {mlsPurchasePaidCustomerMessage({ names: names || null })}{" "}
              <ContactSupportLink
                subject={`MLS purchase – ${purchase.id}`}
                body={`Purchase ID: ${purchase.id}\nMLS: ${names}`}
                label="Contact support"
              />{" "}
              for further information.
            </>
          )}
        </Typography>
      </Alert>
    )
  }

  return null
}
